import Ajax from './data_sources/ajax';
import Thor from './data_sources/thor';

let Fetch = {
  attempts: 1,

  configureFetch() {
    this.configureThor();
    this.configureAjax();
  },

  fetchCached(selectWhenFetch) {
    let cached = this.getCache();
    if (cached) {
      this.setOptions(cached, selectWhenFetch);
      return true;
    }

    if (this.$ajaxData && this.$ajaxData.length) {
      this.ajaxData = JSON.parse(this.$ajaxData.html());
      this.setCache(this.ajaxData);
      this.setOptions(this.ajaxData, selectWhenFetch);
      this.$ajaxData.html('');
      return true;
    }

    return false;
  },

  setOptions(data, selectWhenFetch = null, render = true) {
    if (selectWhenFetch)
      selectWhenFetch = selectWhenFetch instanceof Array ? selectWhenFetch : [selectWhenFetch];

    this.options = data;
    this.reset(false);
    const firstPage = this._getPage(1).data;
    this.isDataFetched = true;

    if (selectWhenFetch) {
      this.selectedValues = this.filterValues(selectWhenFetch);
      this.renderOptions(firstPage, true, false);
      this._execCallbacks('change', this.selectedValues);
    } else if (render) {
      this.renderOptions(firstPage, true);
    }

    this._execCallbacks('fetch', data);
  },

  getOptions(cb) {
    const value = this.options;
    if (cb && typeof cb === 'function') return cb(value);
    return value;
  },

  fetch(customParams, selectWhenFetch = null) {
    if (selectWhenFetch && !selectWhenFetch.length) selectWhenFetch = null;
    if (this.fetchCached(selectWhenFetch)) return;

    customParams = customParams || this.$component.data('ajax-custom-params') || {};

    const params = {
      per_page: this.perPage,
      ...customParams
    };

    const fetchMethod = this.thor ? this.fetchThor(params) : this.fetchAjax(params);
    fetchMethod
      .done(data => this.onSuccess(data, selectWhenFetch))
      .fail(err => this.onFail(err, fetchMethod, selectWhenFetch));
  },

  onSuccess(data, selectWhenFetch) {
    if (this.collectionRoot)
      data = data[this.collectionRoot];

    data = typeof this.formatFunction === 'function' ? this.formatFunction(data) : data;

    if (this.enableCache)
      this.setCache(data);

    this.setOptions(data, selectWhenFetch);
  },

  onFail(err, fetchMethod, selectWhenFetch) {
    // Phoenix call
    if (this.attempts > 0) {
      setTimeout(() => {
        fetchMethod
          .done(data => this.onSuccess(data, selectWhenFetch))
          .fail(err => this.onFail(err, fetchMethod, selectWhenFetch));

        this.attempts -= 1;
      }, 1000);
    } else {
      this.renderError('<div>Ops! Não foi possível obter os dados!</div>' +
        '<small>Se o erro persistir, entre em contato com o SAC.</small>');
      this.clearCache();
    }
  }
};

Fetch = Object.assign(
  Fetch,
  Ajax,
  Thor
);

export default Fetch;
